export default "__VITE_ASSET__Co8gcev7__"